import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetSaleRequestShippingAssignmentQueryResponse, GetSaleRequestShippingAssignmentPathParams } from "../../types/GetSaleRequestShippingAssignment";

/**
     * @summary Данные поручения об оплате по отгрузке
     * @link /api/salerequests/:requestId/shippings/:shippingId/assignment
     */
export async function getSaleRequestShippingAssignment (requestId: GetSaleRequestShippingAssignmentPathParams["requestId"], shippingId: GetSaleRequestShippingAssignmentPathParams["shippingId"], options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetSaleRequestShippingAssignmentQueryResponse>["data"]> {
    const { data: resData } = await client<GetSaleRequestShippingAssignmentQueryResponse>({
        method: "get",
        url: `/api/salerequests/${requestId}/shippings/${shippingId}/assignment`,
        ...options
    });
    
    return resData;
};